import React from 'react';

// Competency the stretch signal wants working in a slot: 4 = prefer skilled, 5 = prefer
// the strongest. Baseline (3) draws nothing, so the marks land only where they matter.
const LEVEL_COLOUR = { 4: '#f6b73c', 5: '#e5484d' };

const AREA_LABEL = {
  FRONT_OF_HOUSE: 'FOH skill demand',
  BACK_OF_HOUSE: 'BOH skill demand',
  BAR: 'Bar skill demand',
};

const cellTitle = (s, area) =>
  `${s.startTime}–${s.endTime}  ·  ${(AREA_LABEL[area] || area)}\n` +
  `wants competency ${s.requiredCompetency}\n` +
  `stretch ${s.stretch == null ? 'n/a (no cover)' : s.stretch}  (items ${s.items} / head ${s.headcount})`;

// One thin, axis-aligned track per demand area, sitting directly under that area's demand
// grid. Positions each 30-min mark by clock time over the same timeSlots axis the grid uses.
export function StretchDayStrip({ dayProfile, timeSlots, parseTime }) {
  if (!dayProfile || !timeSlots || timeSlots.length < 2) return null;
  const min = timeSlots[0];
  const span = timeSlots[timeSlots.length - 1] - timeSlots[0];
  if (span <= 0) return null;

  const areas = Object.keys(dayProfile);
  if (!areas.length) return null;

  return (
    <>
      {areas.map((area) => {
        const slots = (dayProfile[area] && dayProfile[area].slots) || [];
        const marks = slots.filter((s) => s.requiredCompetency >= 4);
        return (
          <div key={area} className="schedule-row" style={{ minHeight: 20 }}>
            <div className="row-label" title="Where the schedule wants your higher-skilled staff">
              {AREA_LABEL[area] || area}
            </div>
            <div
              className="shifts-container"
              style={{ position: 'relative', height: 14, background: 'rgba(148,163,184,0.10)', borderRadius: 3 }}
            >
              {marks.map((s, i) => {
                const left = ((parseTime(s.startTime) - min) / span) * 100;
                const width = (0.5 / span) * 100;
                const opacity = 0.55 + 0.45 * Math.min(1, Math.max(0, s.intensity || 0));
                return (
                  <div
                    key={i}
                    title={cellTitle(s, area)}
                    style={{
                      position: 'absolute',
                      left: `${left}%`,
                      width: `${width}%`,
                      top: 0,
                      height: '100%',
                      background: LEVEL_COLOUR[s.requiredCompetency] || LEVEL_COLOUR[4],
                      opacity,
                      borderRadius: 2,
                    }}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
    </>
  );
}

// One-time banner for the top of the Shape of Day section. Renders unconditionally so its
// presence confirms the current bundle is loaded; the copy tells you whether data arrived.
export function StretchLegend({ present }) {
  const key = (colour, label) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#6b7280' }}>
      <span style={{ width: 20, height: 12, borderRadius: 3, background: colour, display: 'inline-block' }} />
      {label}
    </span>
  );
  return (
    <div
      style={{
        display: 'flex', gap: 18, alignItems: 'center', flexWrap: 'wrap',
        margin: '4px 0 12px', padding: '8px 12px', borderRadius: 8,
        background: 'rgba(148,163,184,0.10)', border: '1px solid rgba(148,163,184,0.25)',
      }}
    >
      <span style={{ fontSize: 12, fontWeight: 700, color: '#374151' }}>Skill demand under stretch</span>
      {present ? (
        <>
          {key('#e5484d', 'bring your strongest (5)')}
          {key('#f6b73c', 'prefer skilled (4)')}
          <span style={{ fontSize: 12, color: '#9ca3af' }}>
            thin track under each day · deeper = more stretched · hover for numbers
          </span>
        </>
      ) : (
        <span style={{ fontSize: 12, color: '#9ca3af' }}>
          no stretchProfile in the last response — regenerate against the updated API
        </span>
      )}
    </div>
  );
}
